import { useState, useEffect } from "react"
import { Routes, Route, useLocation } from "react-router-dom"
import { AnimatePresence, motion } from "framer-motion"
import { Toaster } from "sonner"
import Home from "./pages/Home"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Dashboard from "./pages/Dashboard"
import Navbar from "./components/Navbar"
import Loader from "./components/Loader"

let loaderMostrado = false

function App() {
  const location = useLocation()
  const [loaderVisible, setLoaderVisible] = useState<boolean>(() => {
    if (loaderMostrado) return false
    loaderMostrado = true
    return true
  })

  useEffect(() => {
    if (!loaderVisible) return
    const timer = setTimeout(() => setLoaderVisible(false), 1900)
    return () => clearTimeout(timer)
  }, [loaderVisible])

  return (
    <>
      <AnimatePresence>
        {loaderVisible && <Loader key="loader" />}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{
          opacity: loaderVisible ? 0 : 1,
          y: loaderVisible ? -20 : 0
        }}
        transition={{ type: "spring", stiffness: 700, damping: 22, delay: loaderVisible ? 2 : 0.6 }}
      >
        <Navbar />
      </motion.div>

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route index element={<Home loaderVisible={loaderVisible} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </AnimatePresence>

      <Toaster
        position="bottom-right"
        closeButton
        toastOptions={{
          style: {
            borderRadius: '16px',
            fontFamily: 'system-ui, sans-serif',
            fontWeight: '700',
            fontSize: '14px',
            border: '3px solid rgba(255,255,255,0.2)',
            boxShadow: '-4px 4px 3px rgba(0,0,0,0.2)',
          },
          classNames: {
            success: 'toast-success',
            error: 'toast-error',
            info: 'toast-info',
            warning: 'toast-warning',
          }
        }}
      />
    </>
  )
}

export default App
